import { useEffect, useRef, useState } from "react";

export default function useViewportActivation(rootMargin = "300px 0px") {
  const elementRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) {
      setIsActive(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsActive(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (elementRef.current) observer.observe(elementRef.current);
    return () => observer.disconnect();
  }, [rootMargin]);

  return [elementRef, isActive];
}
